import { Button, Modal, Badge } from 'react-bootstrap';
import ReactApexChart from 'react-apexcharts';
import moment from 'moment';
import { useMemo } from 'react';

const ViewPricebook = ({ show, onClose, item, graphData, month, year, vendorName, loading  }) => {

    const chartData = useMemo(() => {
        if (!Array.isArray(graphData) || !item?.raw_material_id) return [];
        const match = graphData.find(d => String(d.raw_material_id) === String(item.raw_material_id));
        console.log('Match found:', match);
        return match?.data?.map(point => ({
            x: moment(point.x).format('DD-MM-YYYY'),
            y: point.y
        })) || [];
    }, [graphData, item]);


    const { minPrice, maxPrice } = useMemo(() => {
        if (!Array.isArray(graphData) || !item?.raw_material_id) return { minPrice: 0, maxPrice: 0 };
        const match = graphData.find(d => String(d.raw_material_id) === String(item.raw_material_id));
        return {
            minPrice: match?.min_price ?? 0,
            maxPrice: match?.max_price ?? 0
        };
    }, [graphData, item]);

    const chartOptions = {
        title: {
            text: `Pricebook Report for ${year}`,
            align: "center",
            style: {
                fontFamily: "poppins",
                fontSize: '15px',
                fontWeight: 500,
                color: '#ff0000',
            },
        },
        chart: {
            id: "area-chart",
            type: "area",
            height: 350,
            zoom: { enabled: false },
            toolbar: {
                show: true,
                tools: {
                    download: true,
                    selection: false,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false,
                },
            },
        },
        xaxis: {
            type: 'category',
            title: {
                text: "Date",
                style: {
                    fontFamily: "poppins",
                    fontSize: '15px',
                    fontWeight: 'semi-bold',
                    color: '#333',
                },
            },
            labels: {
                style: {
                    fontSize: "12px",
                    colors: ["#333"],
                },
            },
        },
        yaxis: {
            title: {
                text: "Price",
                style: {
                    fontFamily: "poppins",
                    fontSize: '15px',
                    fontWeight: 'semi-bold',
                    color: '#333',
                },
            },
        },
        tooltip: {
            x: {
                format: "dd MMM yyyy",
            },
        },
        fill: {
            opacity: 0.8,
            colors: ["rgb(183, 223, 208)"],
        },
        stroke: {
            curve: "smooth",
            width: 2,
            colors: ["rgb(183, 223, 208)"],
        },
        markers: {
            size: 5,
            colors: ["#159564"],
            strokeColor: "#fff",
            strokeWidth: 3,
            shape: "circle",
            hover: { size: 8 },
        },
        dataLabels: {
            enabled: false,
        },
    };

    const series = [{
        name: "Price",
        data: chartData,
    }];

    if (loading) {
        return (
            <Modal show={show} size="lg">
                <div className="modal-content border border-red rounded-xxl">
                    <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                        <h3 className="modal-title text-white">Loading...</h3>
                    </div>
                    <div className="modal-body text-center py-5">
                        <span>Loading graph data...</span>
                    </div>
                </div>
            </Modal>
        );
    }

    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <div className='d-flex align-items-center gap-3 flex-wrap'>
                        <h3 className="modal-title text-white">View Pricebook</h3>
                        <div className="ms-1 me-1 fw-bold text-white">-</div>
                        <Badge bg="none" className='py-1 px-2 fs-4 border border-white text-white'>
                            {item?.raw_material_name || 'N/A'}
                        </Badge>
                    </div>
                    <Button
                        variant=""
                        type="button"
                        className="close px-6 py-2 text-white"
                        data-dismiss="modal"
                        onClick={onClose}
                    >
                        <span>×</span>
                    </Button>
                </div>

                <div className="modal-body">
                    <div className="d-flex justify-content-end mb-3 gap-5 fs-6 fw-semibold">
                        <div className="text-black">Min Price: ₹{minPrice}</div>
                        <div className="text-black">Max Price: ₹{maxPrice}</div>
                    </div>

                    {chartData.length > 0 ? (
                        <ReactApexChart
                            options={chartOptions}
                            series={series}
                            type="area"
                            height={350}
                        />
                    ) : (
                        <div className="text-center text-muted py-5">No chart data available.</div>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default ViewPricebook;
